export const isReferrerFromWhammyDonatePage = (ref: string = document.referrer): boolean => {
  if (!ref) return false

  return /\/campaign\/\d+\/donate(?:\/|$|[?#])/.test(ref)
}
